/**
 * Dark/light mode toggle. The icon/label swap itself is pure CSS, keyed off
 * the [data-theme] attribute (see critical/_header.scss + core/layout/_header.scss)
 * — this only flips the attribute, persists the choice, and adds a small
 * button-press flourish.
 */
const STORAGE_KEY = 'db-theme';

export function initThemeToggle() {
	const toggles = document.querySelectorAll( '[data-theme-toggle]' );
	if ( ! toggles.length ) return;

	const root = document.documentElement;

	const syncPressedState = () => {
		const isDark = root.getAttribute( 'data-theme' ) === 'dark';
		toggles.forEach( ( btn ) => btn.setAttribute( 'aria-pressed', String( isDark ) ) );
	};

	syncPressedState();

	toggles.forEach( ( btn ) => {
		btn.addEventListener( 'click', () => {
			const next = root.getAttribute( 'data-theme' ) === 'dark' ? 'light' : 'dark';
			root.setAttribute( 'data-theme', next );

			try {
				localStorage.setItem( STORAGE_KEY, next );
			} catch {
				// Storage unavailable (private browsing / disabled) — theme still
				// applies for this page view, it just won't persist.
			}

			syncPressedState();

			const gsap = window.gsap;
			if ( gsap && ! window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
				gsap.fromTo( btn, { scale: 0.82 }, { scale: 1, duration: 0.4, ease: 'back.out(2)' } );
			}
		} );
	} );
}
